const getters = {
  layers: state => state.layers,
  layer_works: state => state.layer_works,
  layers_loading: state => state.layers_loading,
  layer_season_uuid: state => state.layer_season_uuid,
  layer_filters: state => state.layer_filters
}

export default getters;
